import React from "react";
import logo from '../../assets/guardian-logo.svg';


const Header =()=>{
    return(
        <>
           <div className="welcomeExperience__header" role="banner">
              <img alt="Guardian-Logo" src={logo} />
            </div> 
            <div className="dob_separator_line" />
            </>
    )
}

export default Header;